import { render, staticRenderFns } from "./AllReportsDialog.vue?vue&type=template&id=70c2510d&scoped=true&"
import script from "./AllReportsDialog.vue?vue&type=script&lang=js&"
export * from "./AllReportsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllReportsDialog.vue?vue&type=style&index=0&id=70c2510d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2510d",
  null
  
)

export default component.exports